export  default class Ticket {
    static modelName = 'Ticket';
    constructor(ticket) {
        this.phase = ticket.phase;
        this.status = ticket.status;
        this.mediatorId = ticket.mediatorId;
    }
}
